import React from "react";

export default function ButtonLoader() {
    return (
        <div className="spinner-border spinner-border-sm text-light" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
}